import React from "react";
import Helmet from "react-helmet";

const defaultImageMap = {
    'greeting_card': '/images/products/default-product-images/card.jpg',
    'journal': '/images/products/default-product-images/notebook.jpg',
    'photo_tile': '/images/products/default-product-images/photoTile.jpg',
    'cushion': '/images/products/default-product-images/cushion.jpg',
    'jigsaw': '/images/products/default-product-images/jigsaw.jpg',
    'photobook': '/images/products/default-product-images/photobook.jpg'
}


const BuildStructuredData = (variants, variant, currency) => {
    const seoName = variant.displayCategory.startsWith('Photo')
        ? `Personalised ${variant.displayCategory}`
        : `Personalised Photo ${variant.displayCategory}`;

    const offers = variants.map(v => ({
        "@type": "Offer",
        "name": seoName,
        "price": (Math.floor(v.price / 100)).toFixed(2),
        "sku": v.productDisplaySKU,
        "priceCurrency": currency.toUpperCase(),
        "availability": "https://schema.org/InStock",
        "itemCondition": "https://schema.org/NewCondition",
    }));

    const cleanPathname = window.location.pathname.split('/').slice(0, -1).join('/');
    const cleanUrl = `${window.location.origin}${cleanPathname}?currency=${currency.toUpperCase()}`;



    return {
        '@context': 'http://schema.org',
        '@type': 'Product',
        image: 'https://jigpaws.com' + defaultImageMap[variant.category],
        description: variant.detailsLong,
        url: cleanUrl,
        category: variant.displayCategory,
        name: seoName,
        brand: { '@type': 'Brand', name: 'Jigpaws' },
        logo: 'https://www.jigpaws.com/images/svg/jigpawsLogoWhite.jpg',
//         "aggregate rating": {
//   "@type": "Aggregate Rating",
//   "ratingValue": "4.8",
//   "reviewCount": "120"
// },
        offers,
    };
};

const StructuredData = ({ variants, variant, currency }) => {
    const structuredData = BuildStructuredData(variants, variant, currency);

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
        </Helmet>
    );
};

export const StructuredDataDebug = ({ variants, variant, currency }) => {
    const structuredData = BuildStructuredData(variants, variant, currency);
    return (
        <pre style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            textAlign: 'left'
        }}>
            {JSON.stringify(structuredData, null, 2)}
        </pre>
    );
};

export default StructuredData;